export function mapMonth(monthNumber: number | string): string | number {
  const monthMap: { [key: number]: string } = {
    1: 'Januar',
    2: 'Februar',
    3: 'Mars',
    4: 'April',
    5: 'Mai',
    6: 'Juni',
    7: 'Juli',
    8: 'August',
    9: 'September',
    10: 'Oktober',
    11: 'November',
    12: 'Desember',
  }

  const monthNum = typeof monthNumber === 'string' ? parseInt(monthNumber, 10) : monthNumber
  return monthMap[monthNum] || monthNum
}